export const selectNotificationListScrollTop = state =>
  state.notificationCenter.notificationListScrollTop;
export const selectWeatherAlertListScrollTop = state =>
  state.notificationCenter.weatherAlertListScrollTop;
export const selectnotificationListPageSize = state =>
  state.notificationCenter.notificationListPageSize;
export const selectWeatherAlertListPageSize = state =>
  state.notificationCenter.weatherAlertListPageSize;
export const selectDataNotificationListBaseTime = state =>
  state.notificationCenter.notificationListBaseTime;
export const selectDataNotificationList = state => state.notificationCenter.notificationList;
export const selectDataNotification = state => state.notificationCenter.notification;
export const selectDataNotificationCache = state => state.notificationCenter.notificationCache;
export const selectDataWeatherAlertListBaseTime = state =>
  state.notificationCenter.weatherAlertListBaseTime;
export const selectDataWeatherAlertList = state => state.notificationCenter.weatherAlertList;
export const selectDataWeatherAlert = state => state.notificationCenter.weatherAlert;
export const selectDataWeatherAlertCache = state => state.notificationCenter.weatherAlertCache;
export const selectNotificationResponseCode = state => state.notificationCenter.responseCode;
